import { auth, database } from '../firebase'
import { withRouter } from 'react-router-dom'

export default withRouter({
  isAuthenticated: localStorage.getItem('isAuthenticated') !== null,
  autenticate(email, senha, onError, onSuccess) {
    auth.signInWithEmailAndPassword(email, senha)
      .then((data) => {
        const uid = data.user.uid
        database.ref('usuarios').child(uid).once('value', ((snap) => {
          var adin = snap.val().admin;
          if (adin === true) {
            this.isAuthenticated = uid
            localStorage.setItem('isAuthenticated', this.isAuthenticated);
            onSuccess(uid)
          }
          else {
            onError("Usuário não autorizado")
            this.loggout(((error) => {
              
            }), ((success) => {

            }))
          }
        }), ((error) => {

        }));
      })
      .catch((u) => {
        onError(u.message)
      })
  },
  loggout(onError, onSuccess) {
    auth.signOut()
      .then((data) => {
        this.isAuthenticated = false
        localStorage.removeItem('isAuthenticated')
        onSuccess()
      })
      .catch((u) => {
        onError(u.message);
      })
  }
})